import CopyToClipboard from 'common/components/CopyToClipboard';
import { I18n } from 'common/i18n';
import React, { useState } from 'react';
import { showSuccessToastNow } from 'common/components/ToastNotification/Toastmaster';
import { ForgeIcon, ForgeIconButton } from '@tylertech/forge-react';
import cx from 'classnames';
import './index.scss';

interface ClickToCopyCodeBlockProps {
  className?: string;
  value: string;
}

const ClickToCopyCodeBlock: React.FC<ClickToCopyCodeBlockProps> = ({ className, value }) => {
  const [copied, setCopied] = useState<boolean>(false);
  const onCopy = () => {
    setCopied(true);
    showSuccessToastNow(I18n.t('shared.components.click_to_copy_code_block.copied_to_clipboard'));
  };

  return (
    <div className={cx('click-to-copy-code-block', className)} data-testid="click-to-copy-code-block">
      <code>{value}</code>
      <CopyToClipboard text={value} onCopy={onCopy}>
        <ForgeIconButton dense ariaLabel={'copy'} data-testid="copy-to-clipboard-btn">
          <ForgeIcon name={copied ? 'check_circle' : 'content_copy'} data-testid="copy-to-clipboard-icon" />
        </ForgeIconButton>
      </CopyToClipboard>
    </div>
  );
};

export default ClickToCopyCodeBlock;
